import { useMemo } from 'react';

/**
 * Try to guess which operating system the user has installed.
 */
export const usePlatform = () =>
  useMemo(() => {
    if ((navigator as any)?.userAgentData) {
      return ((navigator as any).userAgentData.platform as string).toLowerCase() as 'windows' | 'macos' | 'linux';
    }
    if (navigator?.platform) {
      const platform = navigator.platform.toLowerCase();
      if (platform.includes('win')) return 'windows';
      if (platform.includes('mac')) return 'macos';
      if (platform.includes('linux')) return 'linux';
    }
    return 'unknown';
  }, []);
